/** @format */

import React, { useState } from "react";
import * as Yup from "yup";
import { useResetPasswordMutation } from "store/services/authAPI";
import { useFormik } from "formik";
import AuthHeader from "./components/auth-header";
import Swal from "sweetalert2";
import { replaceUnderscoresWithSpaces } from "utils/strings";
// import loginbg from "../../images/Login.png";
import loginbg from "../../images/Login.png";
import { ReactComponent as PadlockIcon } from "images/svg/padlock.svg";
import { useLocation, Navigate, useNavigate } from "react-router-dom";
import { Path } from "utils/constant.data";

const ResetPasswordNew = () => {
  const [isShown, setIsSHown] = useState(false);
  const navigate = useNavigate();

  const [resetPassword, { isLoading: resetting }] = useResetPasswordMutation();

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const token = searchParams.get("token");
  const node = searchParams.get("node");

  const handleSubmit = async (values) => {
    if (token && node) {
      await resetPassword({
        node,
        password: values.password,
        token,
      })
        .unwrap()
        .then((data) => {
          Swal.fire({
            title: "Notice",
            icon: "success",
            text: data?.detail,
            showCloseButton: true,
            customClass: {
              icon: "no-border",
            },
            confirmButtonText: "Ok",
          }).then(() => {
            navigate(Path.LOGIN);
          });
        })
        .catch((error) => {
          const errorText = error?.data?.detail;
          const btnText = "Try Again";

          Swal.fire({
            title: error?.data?.code
              ? replaceUnderscoresWithSpaces(error?.data?.code)
              : "Error Occured",
            iconHtml: ` <i class="fa fa-exclamation-triangle text-danger" aria-hidden="true"></i>`,
            text: errorText || "Error Occured",
            showCloseButton: true,
            customClass: {
              icon: "no-border",
            },
            cancelButtonText: btnText,
            showConfirmButton: false,
            showCancelButton: true,
          });
        });
    } else {
      Swal.fire({
        title: "Error",
        iconHtml: ` <i class="fa fa-exclamation-triangle text-danger" aria-hidden="true"></i>`,
        text: "Error Occured",
        showCloseButton: true,
        customClass: {
          icon: "no-border",
        },
        cancelButtonText: "Ok",
        showConfirmButton: false,
        showCancelButton: true,
      });
    }
  };

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: PasswordSchema,
    onSubmit: handleSubmit,
    enableReinitialize: true,
  });

  const togglePassword = () => {
    setIsSHown((isShown) => !isShown);
  };

 

  if (!token || !node) {
    return <Navigate to={Path.LOGIN} />;
  }

  return (
    <>
      <div
        className="login-main-page auth-page"
        style={{
          background:"url(" + loginbg + ")",
          backgroundSize: "contain",
        }}
      >
        <AuthHeader />

        <div className="login-wrapper w-100 mt-4">
          <div className="container h-100">
            <div className="row h-100 align-items-center justify-content-center">
              <div className="col-xl-6 mt-3">
                <div className="card auth-card">
                  <div className="card-body p-0">
                    <div className="row m-0">
                      <div className="col-xl-12 col-md-12">
                        <div className="sign-in-your">
                          <h4 className="fs-20 font-w800 text-black">
                            Create a New Password
                          </h4>

                          <p className="mb-2 welcome">
                            Ooh! Happy to help recover your account
                            <span>
                              <svg
                                width="26"
                                height="26"
                                viewBox="0 0 26 26"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M20.895 22.0365C15.9041 26.3972 8.3234 25.886 3.96348 20.8951C-0.397189 15.9041 0.113974 8.32346 5.10493 3.96278C10.0959 -0.397137 17.6765 0.11402 22.0372 5.10573C26.3971 10.0959 25.886 17.6766 20.895 22.0365Z"
                                  fill="#FFD273"
                                  stroke="#213D8B"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M12.3794 13.5412C10.7027 11.6217 8.77869 10.1923 6.89012 9.32227C4.63816 11.8637 4.56577 15.7389 6.8592 18.364C9.15263 20.9884 13.0022 21.4378 15.8233 19.5462C15.2149 17.5596 14.0561 15.4592 12.3794 13.5412Z"
                                  fill="#213D8B"
                                  stroke="#213D8B"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M10.9901 14.7561C9.51545 13.0696 7.39844 12.287 5.3244 12.4408C4.89391 14.4749 5.38472 16.6779 6.85863 18.3651C8.33255 20.0517 10.4496 20.8342 12.5236 20.6797C12.9556 18.6464 12.464 16.4434 10.9901 14.7561Z"
                                  fill="#F04A62"
                                  stroke="#213D8B"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M13.0587 5.89844L13.4138 8.21674L11.0947 7.61436"
                                  stroke="#213D8B"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M20.0436 13.8959L17.7954 13.2324L18.0811 15.611"
                                  stroke="#213D8B"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                            </span>
                          </p>

                          <form
                            className="form mt-4"
                            onSubmit={formik.handleSubmit}
                          >
                            <div className="form-group mb-3">
                              <label>
                                {" "}
                                <strong>Password</strong>
                              </label>

                              <div className="password__container">
                                <PadlockIcon />
                                <input
                                  type={isShown ? "text" : "password"}
                                  id="password"
                                  name="password"
                                  placeholder="Enter Password"
                                  {...formik.getFieldProps("password")}
                                ></input>
                                <button type="button" onClick={togglePassword}>
                                  <div class="icon">
                                    {isShown ? (
                                      <i class="bi bi-eye"></i>
                                    ) : (
                                      <i class="bi bi-eye-slash"></i>
                                    )}
                                  </div>
                                </button>
                              </div>

                              {formik.touched.password &&
                              formik.errors.password ? (
                                <div className="text-danger mt-2 fs-12">
                                  {formik.errors.password}
                                </div>
                              ) : null}
                            </div>

                            <div className="form-group mb-3">
                              <label>
                                {" "}
                                <strong>Confirm Password</strong>
                              </label>

                              <div className="password__container">
                                <PadlockIcon />
                                <input
                                  type={isShown ? "text" : "password"}
                                  id="confirmPassword"
                                  name="confirmPassword"
                                  className="form-control"
                                  placeholder="Confirm Password"
                                  {...formik.getFieldProps("confirmPassword")}
                                ></input>
                                <button type="button" onClick={togglePassword}>
                                  <div class="icon">
                                    {isShown ? (
                                      <i class="bi bi-eye"></i>
                                    ) : (
                                      <i class="bi bi-eye-slash"></i>
                                    )}
                                  </div>
                                </button>
                              </div>

                              {formik.touched.confirmPassword &&
                              formik.errors.confirmPassword ? (
                                <div className="text-danger mt-2 fs-12">
                                  {formik.errors.confirmPassword}
                                </div>
                              ) : null}
                            </div>

                            <div className="text-center">
                              <button
                                type="submit"
                                className="btn btn-primary btn-block"
                              >
                                {resetting ? (
                                  <span
                                    role="status"
                                    aria-hidden="true"
                                    className="spinner-border spinner-border-sm ms-2"
                                  ></span>
                                ) : (
                                  "Reset Password"
                                )}
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ResetPasswordNew;

const PasswordSchema = Yup.object().shape({
  password: Yup.string()
    .required("Password is required")
    .min(4, "Password is too short - should be 4 chars minimum"),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password"), null], "Password must match")
    .required("Confirm Password is Required"),
});

// http:///reset-password?token=G6RPB0HiKzAEQHavLnGrdvwT1osYdm&amp;node=olacoderpad@gmail.co
